module.exports = __webpack_public_path__ + "static/img/wechat_pay.b8a93b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/movie/wechat_pay.png
// module id = g9Hz
// module chunks = 1